export var MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
var inGoodCondition = true;
/*DENNA ANVÄNDS JUST NU FÖR VALIDERING AV KONTROLL*/
$('#inspection-case-form').submit(function (event) {
    var checkboxes = $(':checkbox').toArray();
    var inspectionLabel = $(this).data('label-name');
    if (checkboxes.length > 0 && inGoodCondition === false) {
        var anyBoxChecked = checkboxes.some(function (checkbox) { return checkbox.checked; });
        if (!anyBoxChecked) {
            $('#maintenance-action-warning').removeClass('hidden');
            return false;
        }
        window['dataLayer'].push({
            'event': 'MinVilla_FinishInspection',
            'eventCategory': 'MV Inspection',
            'eventAction': 'Inspection finished',
            'eventLabel': inspectionLabel,
            'eventValue': $(':checkbox:checked').length
        });
    }
    else {
        window['dataLayer'].push({
            'event': 'MinVilla_FinishInspection',
            'eventCategory': 'MV Inspection',
            'eventAction': 'Inspection finished',
            'eventLabel': inspectionLabel
        });
    }
    return true;
});
$('.ts-handle-inspection-dialog-condition').on('click', function () {
    var button = $(this).val();
    var maintenanceForm = document.getElementById('maintenance-action-values');
    var commentText = document.getElementById('inspection-comment');
    if (button === 'False') {
        maintenanceForm.classList.remove('hidden');
        commentText.classList.add('hidden');
        inGoodCondition = false;
    }
    else if (button === 'True') {
        maintenanceForm.classList.add('hidden');
        commentText.classList.remove('hidden');
        inGoodCondition = true;
    }
    toggleManualMaintenanceDescription();
});
function handleFinishCaseMaintenanceDescriptionChange() {
    var selectedDescriptionId = $('#maintenanceDescriptions option:selected').val();
    if (selectedDescriptionId === '') {
        $('#title-element').removeClass('hidden');
        $('#title-element :input').attr('required', 'required');
        $('#description-element').removeClass('hidden');
    }
    else {
        $('#title-element').addClass('hidden');
        $('#title-element :input').removeAttr('required');
        $('#description-element').addClass('hidden');
    }
}
function toggleManualMaintenanceDescription() {
    if (shouldUseManualMaintenanceDescription()) {
        enableManualMaintenanceFields();
    }
    else {
        disableManualMaintenanceFields();
    }
}
function shouldUseManualMaintenanceDescription() {
    var isInspectionInBadCondition = $('#faulty-option').is(':checked');
    var hasSelectedManualOption = $('#maintenance-description-manual').is(':checked');
    var hasOnlyManualMaintenance = $('#maintenance-description-manual[type=checkbox]').length === 0;
    return isInspectionInBadCondition && (hasSelectedManualOption || hasOnlyManualMaintenance);
}
function enableManualMaintenanceFields() {
    $('#title-element').removeClass('hidden');
    $('#title-element :input').attr('required', 'required');
    $('#description-element').removeClass('hidden');
    $('#maintenance-action-title').prop('disabled', false);
    $('#maintenance-action-description').prop('disabled', false);
}
function disableManualMaintenanceFields() {
    $('#title-element').addClass('hidden');
    $('#title-element :input').removeAttr('required');
    $('#description-element').addClass('hidden');
    $('#maintenance-action-title').prop('disabled', true);
    $('#maintenance-action-description').prop('disabled', true);
}
export function handleStatusChange(isCompleted, $years, $months) {
    if (isCompleted) {
        handleDatesOnStatusIsCompleted($years, $months);
    }
    else {
        handleDatesOnStatusIsNotCompleted($years, $months);
    }
}
function handleDatesOnStatusIsCompleted($years, $months) {
    var today = new Date();
    var chosenYear = parseInt($years.val().toString());
    hideFutureYears($years);
    if (chosenYear === today.getFullYear()) {
        hideFutureMonths($months);
    }
    else {
        showAllMonths($months);
    }
}
function handleDatesOnStatusIsNotCompleted($years, $months) {
    var today = new Date();
    var chosenYear = parseInt($years.val().toString());
    hidePastYears($years);
    if (chosenYear === today.getFullYear()) {
        hidePastMonths($months);
    }
    else {
        showAllMonths($months);
    }
}
function handlePlannedYearChange(isCompleted, $years, $months) {
    if (isCompleted) {
        handleDatesOnStatusIsCompleted($years, $months);
    }
    else {
        handleDatesOnStatusIsNotCompleted($years, $months);
    }
}
function hidePastYears($years) {
    var currentYear = new Date().getFullYear();
    var options = $years.find('option').toArray();
    options.forEach(function (option) {
        if (parseInt(option.value) < currentYear) {
            option.setAttribute('disabled', 'disabled');
            option.setAttribute('hidden', 'true');
        }
    });
    if (parseInt($years.val().toString()) < currentYear) {
        $years.val(currentYear);
    }
}
function hidePastMonths($months) {
    var currentMonth = new Date().getMonth() + 1;
    var options = $months.find('option').toArray();
    options.forEach(function (option) {
        if (parseInt(option.value) < currentMonth) {
            option.setAttribute('disabled', 'disabled');
            option.setAttribute('hidden', 'true');
        }
    });
    if (parseInt($months.val().toString()) < currentMonth) {
        $months.val(currentMonth);
    }
}
function hideFutureYears($years) {
    var currentYear = new Date().getFullYear();
    var options = $years.find('option').toArray();
    options.forEach(function (option) {
        if (parseInt(option.value) > currentYear) {
            option.setAttribute('disabled', 'disabled');
            option.setAttribute('hidden', 'true');
        }
    });
    if (parseInt($years.val().toString()) > currentYear) {
        $years.val(currentYear);
    }
}
function hideFutureMonths($months) {
    var currentMonth = new Date().getMonth() + 1;
    var options = $months.find('option').toArray();
    options.forEach(function (option) {
        if (parseInt(option.value) > currentMonth) {
            option.setAttribute('disabled', 'disabled');
            option.setAttribute('hidden', 'true');
        }
    });
    if (parseInt($months.val().toString()) > currentMonth || $months.val() === null) {
        $months.val(currentMonth);
    }
}
function showAllMonths($months) {
    $months.find('option').removeAttr('disabled');
    $months.find('option').removeAttr('hidden');
}
function resetDateDropDown() {
    var $years = $('.js-planned-completion-date').find('[data-role=\'year\']');
    var $months = $('.js-planned-completion-date').find('[data-role=\'month\']');
    var currentYear = new Date().getFullYear();
    var currentMonth = new Date().getMonth() + 1;
    var monthsOptions = $months.find('option').toArray();
    var yearsOptions = $years.find('option').toArray();
    monthsOptions.forEach(function (option) {
        option.removeAttribute('disabled');
        option.removeAttribute('hidden');
        option.removeAttribute('selected');
        if (option.value === currentMonth.toString()) {
            option.setAttribute('selected', 'selected');
        }
    });
    yearsOptions.forEach(function (option) {
        option.removeAttribute('disabled');
        option.removeAttribute('hidden');
        option.removeAttribute('selected');
        if (option.value === currentYear.toString()) {
            option.setAttribute('selected', 'selected');
        }
    });
}
export function initIsCompletedChangeListener() {
    $('input[type=radio][name=IsCompleted]').on('change', function (evt) {
        resetDateDropDown();
        var $years = $('.js-planned-completion-date').find('[data-role=\'year\']');
        var $months = $('.js-planned-completion-date').find('[data-role=\'month\']');
        var isCompleted = $(evt.target).val() === 'True';
        handleStatusChange(isCompleted, $years, $months);
    });
}
export function initPlannedCompletionDateChangeListener() {
    $('.js-planned-completion-date').on('change', function (evt) {
        var $year = $(evt.target).closest('.js-planned-completion-date').find('[data-role=\'year\']');
        var $month = $(evt.target).closest('.js-planned-completion-date').find('[data-role=\'month\']');
        var isCompleted = $('input[type=radio][name=IsCompleted]').filter(':checked').first().val() === 'True';
        handlePlannedYearChange(isCompleted, $year, $month);
    });
}
function initPlannedCompletionDateChange() {
    $('.js-completion-date').on('change', function (evt) {
        var $year = $(evt.target).closest('.js-completion-date').find('[data-role=\'year\']');
        var $month = $(evt.target).closest('.js-completion-date').find('[data-role=\'month\']');
        handleDatesOnStatusIsCompleted($year, $month);
    });
}
jQuery(function () {
    initIsCompletedChangeListener();
    initPlannedCompletionDateChangeListener();
    initPlannedCompletionDateChange();
    $('.maintenance-action-toggle').on('change', function (evt) {
        var target = evt.target;
        var details = $(target).closest('.maintenance-action-toggle').next('.maintenance-action-details');
        if (target.checked) {
            details.show({ duration: 200 });
            details.find('input[disabled]').attr('disabled', null);
        }
        else {
            details.hide({ duration: 200 });
            details.find('input[required]').attr('disabled', 'disabled');
        }
        toggleManualMaintenanceDescription();
    });
    $('.button--maintenance-dialog').on('click', function () {
        var $years = $('.js-planned-completion-date').find('[data-role=\'year\']');
        var $months = $('.js-planned-completion-date').find('[data-role=\'month\']');
        var isCompleted = $('input[type=radio][name=IsCompleted]').filter(':checked').first().val() === 'True';
        handleStatusChange(isCompleted, $years, $months);
    });
});
